"use client";
import { PDPProduct } from "@/features/product/types";
import { convertProductToCartItem } from "@/lib/centra/convertToCartItem/convertToCartItem";
import useLocation from "@/lib/centra/hooks/useLocation";
import { useCart } from "@/lib/centra/hooks/useSelection";
import { ProductVariant } from "@/lib/centra/localAtomics";
import {
  eventAddToCart,
  generateGTagItem,
} from "@/lib/utils/Analytics/Functions";
import { ProductPricesWithDiscount } from "@frend-digital/centra/types/product";
import { Sizes } from "./ActionSection";
import { useEasySizeStore } from "./SizeGuide/easysize";

export interface IUseAddToCartProps {
  sizes: Sizes;
  product: PDPProduct | ProductVariant;
  setModalOpen: () => void;
  prices: ProductPricesWithDiscount;
}

declare global {
  interface Window {
    EasySizeParametersDebug: {
      easysize: {
        pageview_id: string;
      };
    };
  }
}

export const useAddToCart = ({
  product,
  sizes,
  setModalOpen,
  prices,
}: IUseAddToCartProps) => {
  const cart = useCart();
  const { currency } = useLocation();

  const addToCart = () => {
    cart.modal.openModal();
    if (product?.comingSoon || !sizes.selectedSize?.stock) {
      setModalOpen();
      return;
    }

    if (!sizes?.selectedSize) return false;

    if (sizes?.selectedSize?.itemId) {
      cart.addItem.mutate(
        {
          itemId: sizes?.selectedSize?.itemId,
          cartItem: convertProductToCartItem(
            {
              ...product,
              prices,
            },
            sizes?.selectedSize?.itemId,
          ),
        },
        {
          onSuccess(data) {
            cart.modal.openModal();
          },
        },
      );

      try {
        eventAddToCart({
          currency: currency || "",
          items: [
            generateGTagItem(
              product,

              prices?.priceAsNumber,
            ),
          ],
        });
        if (
          window?.EasySizeParametersDebug?.easysize?.pageview_id &&
          product?.uri
        ) {
          const pageViewId =
            window?.EasySizeParametersDebug?.easysize?.pageview_id;
          useEasySizeStore.getState().trackPageView(product?.uri, pageViewId);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  return {
    addToCart,
    isLoading: cart.addItem.isPending,
  };
};
